import type { QualityDocType } from '@entities/mto';

export type TabId = 'bulk' | 'lots' | 'applications' | 'validity' | 'deficit';

export interface TabDef {
  id: TabId;
  label: string;
  /** Короткое пояснение раздела под табами. */
  hint: string;
}

export const TABS: readonly TabDef[] = [
  {
    id: 'bulk',
    label: 'Групповая загрузка',
    hint: 'Загрузите сразу много файлов документов качества — нейросеть сама определит тип каждого (паспорт / сертификат / декларация), извлечёт реквизиты и подберёт партию. Проверьте таблицу и импортируйте всё одной кнопкой.',
  },
  {
    id: 'lots',
    label: 'Партии и документы',
    hint: 'Реестр партий материала. Откройте партию, чтобы вести её паспорта, сертификаты и декларации.',
  },
  {
    id: 'applications',
    label: 'Применение',
    hint: 'Факты применения партий на объекте — что и куда уложено (для прослеживаемости к АОСР).',
  },
  {
    id: 'validity',
    label: 'Действительность документов',
    hint: 'Действителен ли документ качества на дату работ. Проверяется по сроку действия документа, без искусственного интеллекта.',
  },
  {
    id: 'deficit',
    label: 'Дефицит документов',
    hint: 'Применённые партии без действительного документа качества: документа нет, он просрочен или срок не подтверждён.',
  },
];

/** Спец-значения селекта партии в строке предпросмотра. */
export const NEW_LOT = '__new__';
export const SKIP_ROW = '__skip__';

export type BulkStatus = 'pending' | 'importing' | 'done' | 'error' | 'skip';

/** Редактируемая строка предпросмотра массовой загрузки. Реквизиты предзаполнены
 *  извлечением, пользователь правит перед импортом (гейт HITL). */
export interface BulkRow {
  /** Ключ строки: файл и документ в нём (`index-part`). */
  key: string;
  /** Индекс файла в пачке — по нему берётся `File` при импорте. */
  index: number;
  /** Документ в файле-пачке: «3 из 31», страницы — только они уходят в документ. */
  part: number;
  parts: number;
  pages: [number, number] | null;
  filename: string;
  docType: '' | QualityDocType;
  number: string;
  docDate: string;
  issuer: string;
  validUntil: string;
  nomenclature: string;
  /** Выбор партии: id существующей | `NEW_LOT` | `SKIP_ROW`. */
  lotChoice: string;
  lotNo: string;
  /** Как подобрана существующая партия (для подсказки «проверьте»). */
  matchedBy: 'lot_no' | 'nomenclature' | null;
  /** Диагностика извлечения (пометки модели) либо ошибка чтения файла. */
  note: string | null;
  status: BulkStatus;
  resultMsg: string | null;
}
